import { ensureString } from 'ensure-string';

import { calculateResidual } from './util/calculateResidual';
import { createLabeledRecords } from './util/createLabeledRecords';
import { getMetaTGA } from './util/getMetaTGA';
import { improveRelativeResult } from './util/improveRelativeResult';
import { parseCurveValues } from './util/parseCurveValues';

const variables = {
  't-s': { code: 't', label: 'time' },
  'Ts-°C': { code: 'x', label: 'Temperature recorded' },
  'Tr-°C': { code: 'r', label: 'Temperature programmed' },
  'Value-mg': { code: 'y', label: 'Weight' },
  'Value-mW': { code: 'p', label: 'Power' },
  'Value-%': { code: '%', label: 'Percent' },
};

export function tgaParseMettlerToledo(arrayBuffer) {
  const text = ensureString(arrayBuffer);

  let results = [];
  // TGA text format may contain many parts separated by 'Curve Name'
  const parts = text.split(/(?=Curve Name:)/);
  for (const part of parts) {
    if (part.startsWith('Curve Name:')) {
      let labeledRecords = createLabeledRecords(part);
      let parsedCurveValues;
      if (labeledRecords.has('Curve Values')) {
        parsedCurveValues = parseCurveValues(
          labeledRecords.get('Curve Values'),
        );
        labeledRecords.set('Curve Values', parsedCurveValues);
      }

      improveTGALabeledRecords(labeledRecords);

      const data = {};
      for (let i = 0; i < parsedCurveValues.units.length; i++) {
        const variableName =
          parsedCurveValues.labels && parsedCurveValues.labels[i];
        const units = parsedCurveValues.units && parsedCurveValues.units[i];
        const dataValues = parsedCurveValues.data && parsedCurveValues.data[i];
        const variable = variables[`${variableName}-${units}`];
        if (variable && variable.code) {
          data[variable.code] = {
            units,
            data: dataValues,
            label: variable.label,
          };
        }
      }

      let result = {
        meta: getMetaTGA(labeledRecords),
        variables: data,
        info: {
          dataType: 'TGA',
        },
      };

      improveRelativeResult(result);
      calculateResidual(result);

      results.push(result);
    }
  }
  return results;
}

function improveTGALabeledRecords(labeledRecords) {
  let record = labeledRecords.get('Curve Values');
  let value = `${record.data[record.data.length - 1][0]} ${record.units[
    record.data.length - 1
  ].replace(/[[\]]/g, '')}`;
  labeledRecords.set('Initial Value', value);
}
